import React, { useRef, useState } from "react";

const VideoPlayer = ({ src, link }) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showButton, setShowButton] = useState(true);

  const togglePlay = () => {
    const video = videoRef.current;
    if (!video) return;

    if (isPlaying) {
      video.pause();
    } else {
      video.play();
    }
    setIsPlaying(!isPlaying);
    flashButton();
  };

  const flashButton = () => {
    setShowButton(true);
    setTimeout(() => setShowButton(false), 800);
  };

  const handleEnded = () => setIsPlaying(false);

  return (
    <div
      onClick={togglePlay}
      style={{
        position: "relative",
        width: "100%",
        backgroundColor: "#000",
        borderRadius: "8px",
        overflow: "hidden",
        aspectRatio: "6/1",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <video
        ref={videoRef}
        src={src}
        onEnded={handleEnded}
        style={{ width: "100%", display: "block" }}
      />

      {/* Play/Pause Button */}
      <div
        style={{
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "80px",
          height: "80px",
          borderRadius: "50%",
          backgroundColor: "rgba(0, 0, 0, 0.55)",
          backdropFilter: "blur(4px)",
          transition: "opacity 0.3s ease, transform 0.2s ease",
          opacity: showButton ? 1 : 0,
          transform: showButton ? "scale(1)" : "scale(0.85)",
          pointerEvents: "none",
        }}
      >
        {isPlaying ? (
          // Pause icon
          <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
            <rect x="5" y="3" width="4" height="18" rx="1" />
            <rect x="15" y="3" width="4" height="18" rx="1" />
          </svg>
        ) : (
          // Play icon
          <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
            <polygon points="6,3 20,12 6,21" />
          </svg>
        )}
      </div>
    </div>
  );
};

export default VideoPlayer;
